import React from 'react';
import './App.css';
import { BrowserRouter,Routes,Route } from 'react-router-dom'
import HomeScreen from './screens/HomeScreen'
import OurGallery from './screens/OurGallery'
import Services from './screens/Services'
import ContactUs from './screens/ContactUs'
import AboutUs from './screens/AboutUs'
import Navbar from './components/NavBar';
import Footer from './components/Footer';
import FloatingButtons from './components/FloatingButtons';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <div className="app-root">
    <BrowserRouter>
    <Navbar/>
      <Routes>
        <Route path='/' element={<HomeScreen/>} />
        <Route path='/photos' element={<OurGallery/>}/>
        <Route path='/Services' element={<Services/>}/>
        <Route path='/Contact' element={<ContactUs/>} />
        <Route path='/About' element={<AboutUs/>} />
      </Routes>
        <Footer />
        <FloatingButtons />
        <ScrollToTop />
      </BrowserRouter>
    </div>
  )
}

export default App